import { useState } from 'react'
import { ScrollView, View, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'
const ARinformationonline = ({ navigation, route }: any) => {
  const {
    values,
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    noOfExemptions,
    totalExcemptions
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()
  const { postaronline, loading } = useFormsStore()



  const data = {
    essUserOnBoardingFormKey: essUserOnBoardingFormKey,
    essObKey: essUserOnBoardingKey,
    completeOnline: true,
    essUserKey: intializestore.initializeData.userkey,
    entityId: personalstore.personalData?.entityId,
    filingStatus: values.filingStatus,
    noOfExemptions: noOfExemptions,
    noOfDependents: values.noOfDependents,
    totalExcemptions: totalExcemptions,
    additionalAmount: values.additionalAmount ? values.additionalAmount : null,
    qualifyLowIncome: Number(values.qualifyLowIncome) == 0 ? false : true,

  }

  const handlesubmit = async (signatureDataURL: any) => {
    const payload = { ...data, sign: signatureDataURL }
    const response = await postaronline(payload)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AR Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('ARinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",
            noOfExemptions,
            totalExcemptions
          })
        }
        onSubmit={handlesubmit}
      />
    </>
  )
}
export default ARinformationonline
